import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FormContactState {
  private formData?: FormGroup;

  setFormData(data: FormGroup) {
    this.formData = data;
  }

  getFormData(): FormGroup | undefined {
    return this.formData;
  }

  clear() {
    this.formData = undefined;
  }
}
